import styled, { css } from 'styled-components';
import { FORM_INPUT_COMPONENT_TYPES, FORM_INPUT_TYPES } from './types';
import { WrapperDefault } from '../Shared/Shared';
export const FormInputWrapper = styled(WrapperDefault)``;

export const FormInputLabel = styled.label<{ error?: boolean; inputType: keyof typeof FORM_INPUT_COMPONENT_TYPES }>`
  display: flex;
  gap: 15px;
  margin: 35px 0 10px 0;
  input {
    width: 40px;
    height: 40px;
    border: none;
    border-bottom: 2px solid var(--primary-gray);
    color: var(--black);
    font-size: 28px;
    text-align: center;
    background-color: transparent;
    ${({ error }) =>
      error &&
      css`
        border-bottom: 2px solid var(--error);
        color: var(--error);
      `}
    &:focus {
      outline: none;
      border-bottom: 2px solid var(--black);
    }
    ${({ inputType }) =>
      inputType === FORM_INPUT_TYPES.DATE &&
      css`
        width: 64px;
        :last-child {
          width: 114px;
        }
      `}
  }

  @media (max-width: 1200px) {
    input,
    input:last-child {
      width: calc(100% / ${({ inputType }) => (inputType === FORM_INPUT_TYPES.DATE ? 3 : 4)});
    }
  }

  ${({ error }) =>
    error &&
    css`
      color: var(--error);
      margin-bottom: 0;
    `}
`;

export const ResendCode = styled.button`
  user-select: none;
  opacity: 0.6;
  font-size: 12px;
  font-weight: 800;
  border: none;
  background: none;
  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }
  ${({ disabled }) =>
    disabled &&
    css`
      opacity: 0.5;
      cursor: not-allowed;
      &:hover {
        opacity: 0.5;
      }
    `}
`;
export const ResendCodeTimer = styled.span`
  opacity: 0.6;
  font-size: 12px;
  font-weight: 800;
  user-select: none;
  &:hover {
    opacity: 0.8;
  }
`;
